import { Component, OnInit } from '@angular/core';
import { Subscription, interval, AsyncSubject, Observable } from 'rxjs';
import { loadURLSVGs } from '@dds-uicore/all';
import { DataService } from '../data.service';
import {
  AgileFileDownloadRequest,
  DownloadFilesInfo,
} from '../model/agile-file-download-request';
import { AgileFileInfo } from '../model/agile-file-info';
import { DownloadStatusModel } from '../model/download-status-model';
import { UploadStatusModel } from '../model/upload-status-model';
import { AgileSDKService } from '../services/agile-sdk.service';
import { AntiVirusScanService } from '../services/anti-virus-scan.service';
import { FileCatalystAPIService } from '../services/file-catalyst-api.service';
import { ScanResponseInfo } from '../model/scan-response-info';
import { URLParams } from '../model/urlparams';
import { AgileFileUploadRequest } from '../model/agile-file-upload-request';
import { AgileReplaceFileRequest } from '../model/agile-replace-file-request';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { FileCacheWARequest } from '../model/file-cache-warequest';
import { AVScanReq } from '../model/avscan-req';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-transfer-status-v2',
  templateUrl: './transfer-status-v2.component.html',
  styleUrls: ['./transfer-status-v2.component.scss'],
})
export class TransferStatusV2Component implements OnInit {
  constructor(
    private dataService: DataService,
    private aglService: AgileSDKService,
    private avScanServ: AntiVirusScanService,
    private fcService: FileCatalystAPIService,
    private router: Router
  ) {}

  uploadCount: number;
  downloadCount: number;

  data_test_upload = [];
  data_test_download = [];
  data_test_upload_child = [];
  selectedIndex: number = null;

  uploadDirection = 'UPLOAD';
  downloadDirection = 'DOWNLOAD';

  downloadSelectedIndex: number = null;

  inProgressStatus: string = 'inprogress';
  completeStatus: string = 'complete';
  failedStatus: string = 'failed';
  notStartedStatus: string = 'notstarted';
  uploadValid: boolean = false;
  downloadValid: boolean = false;

  uploadFileInfo: AgileFileInfo[] = [];

  uploadFiles: UploadStatusModel[] = [];
  downloadFiles: DownloadStatusModel[] = [];
  filesToUpload: string[];

  // fileDownloadReqs:AgileFileDownloadRequest ;

  ngOnInit(): void {
    loadURLSVGs(['https://uicore.dellcdn.com/1.3.2/svgs/dds__doc-check.svg']);
    this.trackUploads();
    this.trackDownloads();
  }
  findDetails(dataitem) {
    // console.log('in find details method')
    return this.uploadFiles.filter((x) => x.fileName === dataitem.fileName);
  }
  setIndex(index: number, dataitem: any) {
    this.selectedIndex = index;
    dataitem.isActive = !dataitem.isActive;
  }

  findDownloadDetails(dataitem: DownloadStatusModel) {
    // console.log('data item file name ',dataitem.fileName)
    return this.downloadFiles.filter((x) => x.fileName === dataitem.fileName);
    // return this.downloadFiles
  }
  setDownloadIndex(index: number, dataitem: any) {
    this.selectedIndex = index;
    dataitem.isActive = !dataitem.isActive;
  }
  async trackUploads() {
    this.uploadFiles = this.dataService.getUploadFiles();
    console.log('Upload Files ', this.uploadFiles);
    if (this.uploadFiles != undefined && this.uploadFiles.length > 0) {
      this.uploadValid = true;
      this.uploadFiles.forEach((uploadFile) => {
        if (uploadFile.acceleratedTransfer) {
          console.log('Accelerated Upload');
          if (uploadFile.fileCacheStatus == this.completeStatus) {
            if (
              uploadFile.avScanStatus == this.failedStatus ||
              uploadFile.avScanStatus == this.notStartedStatus
            ) {
              console.log(
                'checking the remote file ',
                this.dataService.urlParams.skipFCRemoteList
              );

              console.log(
                'load balanced value ',
                this.dataService.loadBalanced
              );
              if (this.dataService.loadBalanced) {
                this.fcService
                  .getUserDetails(this.dataService.getFCConnectionKey())
                  .subscribe((resp) => {
                    console.log('User Details Resp ', resp);
                    let serverName: string = resp.userEmailAddress;
                    console.log('server name ', serverName);
                    serverName = serverName.toLowerCase();
                    serverName = serverName.replace('@nowhere.com', '');
                    console.log('server name 2 ', serverName);
                    console.log(
                      'data service servers ',
                      this.dataService.servers
                    );
                    let serverIndex: number =
                      this.dataService.servers.indexOf(serverName);
                    console.log('server index ', serverIndex);
                    // getting the user details to get the file server
                    uploadFile.server = serverIndex;
                    // this.scanForVirus_V2(uploadFile).

                    this.checkRemoteFile(uploadFile).subscribe((exists) => {
                      if (exists) {
                        this.scanForVirus_V2(uploadFile).subscribe(
                          (scannedFile) => {
                            console.log(
                              'Successfully scanned file ',
                              scannedFile
                            );
                            if (
                              scannedFile.avScanStatus == this.completeStatus
                            ) {
                              // upload file t o Agile
                              this.uploadFileToAgile(scannedFile, 0);
                            }
                          }
                        );
                      } else {
                        uploadFile.avScanStatus = this.failedStatus;
                        uploadFile.avsScanMessage =
                          'File not Found in the server';
                      }
                    });
                  });
              } else {
                this.checkRemoteFile(uploadFile).subscribe((exists) => {
                  if (exists) {
                    this.scanForVirus_V2(uploadFile).subscribe(
                      (scannedFile) => {
                        console.log('Successfully scanned file ', scannedFile);
                        if (scannedFile.avScanStatus == this.completeStatus) {
                          // upload file to Agile

                          this.uploadFileToAgile(scannedFile, 0);
                        }
                      }
                    );
                  } else {
                    uploadFile.avScanStatus = this.failedStatus;
                    uploadFile.avsScanMessage = 'File not Found in the server';
                  }
                });
              }
            } else if (
              uploadFile.avScanStatus == this.completeStatus &&
              (uploadFile.agileUploadStatus == this.failedStatus ||
                uploadFile.agileUploadStatus == this.notStartedStatus)
            ) {
              console.log(
                'load balanced value ',
                this.dataService.loadBalanced
              );
              if (this.dataService.loadBalanced) {
                this.fcService
                  .getUserDetails(this.dataService.getFCConnectionKey())
                  .subscribe((resp) => {
                    console.log('User Details Resp ', resp);
                    let serverName: string = resp.userEmailAddress;
                    console.log('server name ', serverName);
                    serverName = serverName.toLowerCase();
                    serverName = serverName.replace('@nowhere.com', '');
                    console.log('server name 2 ', serverName);
                    let serverIndex: number =
                      this.dataService.servers.indexOf[serverName];
                    console.log('server index ', serverIndex);
                    // getting the user details to get the file server
                    uploadFile.server = serverIndex;
                    // this.scanForVirus_V2(uploadFile).

                    this.checkRemoteFile(uploadFile).subscribe((exists) => {
                      if (exists) {
                        this.uploadFileToAgile(uploadFile, 0);
                      } else {
                        uploadFile.agileUploadStatus = this.failedStatus;
                        uploadFile.agileUploadMessage =
                          'File not Found in the server';
                      }
                    });

                    // this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                    //   console.log('Successfully scanned file ',scannedFile)
                    //   if(scannedFile.avScanStatus == this.completeStatus){
                    //     // upload file to Agile
                    //     this.uploadFileToAgile(scannedFile);
                    //   }
                    // })
                  });
              } else {
                this.checkRemoteFile(uploadFile).subscribe((exists) => {
                  if (exists) {
                    this.uploadFileToAgile(uploadFile, 0);
                  } else {
                    uploadFile.agileUploadStatus = this.failedStatus;
                    uploadFile.agileUploadMessage =
                      'File not Found in the server';
                  }
                });
                // this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                //   console.log('Successfully scanned file ',scannedFile)
                //   if(scannedFile.avScanStatus == this.completeStatus){
                //     // upload file to Agile
                //     this.uploadFileToAgile(scannedFile);
                //   }
                // })
              }
            }

            // check file in the server and call the AV Scan service
          } else if (
            uploadFile.fileCacheStatus == this.inProgressStatus ||
            uploadFile.fileCacheStatus == this.notStartedStatus
          ) {
            console.log('Job id ', uploadFile.jobid);
            // check the status for the job id

            // this.scanForVirus(uploadFile);
            this.getFCFileCacheStatus(uploadFile).subscribe((cachedFile) => {
              console.log('Completed File Cache for ', cachedFile.fileName);
              // check if the file is present in the server

              if (
                cachedFile != undefined &&
                cachedFile.fileCacheStatus == this.completeStatus
              ) {
                console.log(
                  'load balanced value ',
                  this.dataService.loadBalanced
                );
                if (this.dataService.loadBalanced) {
                  this.fcService
                    .getUserDetails(this.dataService.getFCConnectionKey())
                    .subscribe((resp) => {
                      console.log('User Details Resp ', resp);
                      let serverName: string = resp.userEmailAddress;
                      console.log('server name ', serverName);
                      serverName = serverName.toLowerCase();
                      serverName = serverName.replace('@nowhere.com', '');
                      console.log('server name 2 ', serverName);
                      let serverIndex: number =
                        this.dataService.servers.indexOf(serverName);
                      console.log('server index ', serverIndex);
                      // getting the user details to get the file server
                      uploadFile.server = serverIndex;
                      this.checkRemoteFile(uploadFile).subscribe((exists) => {
                        if (exists) {
                          this.scanForVirus_V2(uploadFile).subscribe(
                            (scannedFile) => {
                              console.log(
                                'Successfully scanned file ',
                                scannedFile
                              );
                              if (
                                scannedFile.avScanStatus == this.completeStatus
                              ) {
                                // upload file to Agile
                                this.uploadFileToAgile(scannedFile, 0);
                              }
                            }
                          );
                        } else {
                          uploadFile.avScanStatus = this.failedStatus;
                          uploadFile.avsScanMessage =
                            'File not Found in the server';
                        }
                      });
                    });
                } else {
                  this.checkRemoteFile(uploadFile).subscribe((exists) => {
                    if (exists) {
                      this.scanForVirus_V2(uploadFile).subscribe(
                        (scannedFile) => {
                          console.log(
                            'Successfully scanned file ',
                            scannedFile
                          );
                          if (scannedFile.avScanStatus == this.completeStatus) {
                            // upload file to Agile
                            this.uploadFileToAgile(scannedFile, 0);
                          }
                        }
                      );
                    } else {
                      uploadFile.agileUploadStatus = this.failedStatus;
                      uploadFile.agileUploadMessage =
                        'File not Found in the server';
                    }
                  });
                }
                // this.scanForVirus(cachedFile).subscribe((scannedFile) => {
                //   console.log('Successfully scanned file ',scannedFile)
                //   if(scannedFile.fileCacheStatus == this.completeStatus){
                //     // upload file to Agile
                //     this.uploadFileToAgile(scannedFile);
                //   }
                // })
              }
            });
          }
        } else {
          console.log('Non-Accelerated Upload');
          if (uploadFile.fileCacheStatus == this.completeStatus) {
            console.log('Non-Accelerated Upload - File Cache Complete');
            if (uploadFile.avScanStatus == this.failedStatus) {
              console.log(
                'Non-Accelerated Upload - File Cache Complete, failed AV scan'
              );

              // this.scanForVirus_V2(uploadFile).subscribe((scannedFile) => {
              //   console.log('Successfully scanned file ',scannedFile)
              //   if(scannedFile.avScanStatus == this.completeStatus){
              //     // upload file to Agile
              //     this.uploadFileToAgile(scannedFile);
              //   }
              // })

              console.log(
                'load balanced value ',
                this.dataService.loadBalanced
              );
              if (this.dataService.loadBalanced) {
                console.log('inside the load balanced section');
                this.fcService
                  .getUserDetails(this.dataService.getFCConnectionKey())
                  .subscribe((resp) => {
                    console.log('User Details Resp ', resp);
                    let serverName: string = resp.userEmailAddress;
                    serverName = serverName.toLowerCase();
                    console.log('server name ', serverName);
                    serverName = serverName.replace('@nowhere.com', '');
                    console.log('server name 2 ', serverName);
                    let serverIndex: number =
                      this.dataService.servers.indexOf(serverName);
                    console.log('server index ', serverIndex);
                    // getting the user details to get the file server
                    uploadFile.server = serverIndex;
                    this.scanForVirus_V2(uploadFile).subscribe(
                      (scannedFile) => {
                        console.log('Successfully scanned file ', scannedFile);
                        if (scannedFile.avScanStatus == this.completeStatus) {
                          // upload file to Agile
                          this.uploadFileToAgile(scannedFile, 0);
                        }
                      }
                    );
                  });
              } else {
                this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                  console.log('Successfully scanned file ', scannedFile);
                  if (scannedFile.avScanStatus == this.completeStatus) {
                    // upload file to Agile
                    this.uploadFileToAgile(scannedFile, 0);
                  }
                });
              }
            } else if (
              uploadFile.avScanStatus == this.completeStatus &&
              uploadFile.agileUploadStatus == this.failedStatus
            ) {
              this.uploadFileToAgile(uploadFile, 0);
            }
          } else if (
            uploadFile.fileCacheStatus == this.inProgressStatus ||
            uploadFile.fileCacheStatus == this.notStartedStatus
          ) {
            console.log('Non-Accelerated Upload - File Cache in progress');
            this.getNonAcceleratedCacheStatus(uploadFile).subscribe(
              (cachedFile) => {
                console.log('Cached File ', cachedFile);
                if (
                  cachedFile != undefined &&
                  cachedFile.fileCacheStatus == this.completeStatus
                ) {
                  console.log(
                    'load balanced value ',
                    this.dataService.loadBalanced
                  );
                  if (this.dataService.loadBalanced) {
                    console.log(
                      'Non-Accelerated Upload - File Cache Complete, in load balanced loop'
                    );
                    uploadFile.server = 0;
                    // this.scanForVirus_V2
                    this.scanForVirus_V2(uploadFile).subscribe(
                      (scannedFile) => {
                        console.log('Successfully scanned file ', scannedFile);
                        if (scannedFile.avScanStatus == this.completeStatus) {
                          // upload file to Agile
                          this.uploadFileToAgile(scannedFile, 0);
                        }
                      }
                    );
                  } else {
                    this.scanForVirus(cachedFile).subscribe((scannedFile) => {
                      console.log('Successfully scanned file ', scannedFile);
                      if (scannedFile.fileCacheStatus == this.completeStatus) {
                        // upload file to Agile
                        this.uploadFileToAgile(scannedFile, 0);
                      }
                    });
                  }

                  //     this.scanForVirus_V2(uploadFile).subscribe((scannedFile) => {
                  //       console.log('Successfully scanned file ',scannedFile)
                  //       if(scannedFile.avScanStatus == this.completeStatus){
                  //         // upload file to Agile
                  //         this.uploadFileToAgile(scannedFile);
                  //       }
                  //     })

                  // }else{
                  //   this.scanForVirus_V2(uploadFile).subscribe((scannedFile) => {
                  //     console.log('Successfully scanned file ',scannedFile)
                  //     if(scannedFile.avScanStatus == this.completeStatus){
                  //       // upload file to Agile
                  //       this.uploadFileToAgile(scannedFile);
                  //     }
                  //   })
                  // }

                  // this.scanForVirus(cachedFile).subscribe((scannedFile) => {
                  //   console.log('Successfully scanned file ',scannedFile)
                  //   if(scannedFile.fileCacheStatus == this.completeStatus){
                  //     // upload file to Agile
                  //     this.uploadFileToAgile(scannedFile);
                  //   }
                  // })
                }
              }
            );
          }
        }
      });
    }
  }

  async trackUploads_v2() {
    this.uploadFiles = this.dataService.getUploadFiles();
    console.log('Upload Files ', this.uploadFiles);
    if (this.uploadFiles != undefined && this.uploadFiles.length > 0) {
      this.uploadValid = true;
      this.uploadFiles.forEach((uploadFile) => {
        if (uploadFile.acceleratedTransfer) {
          console.log('Accelerated Upload');
          if (uploadFile.fileCacheStatus == this.completeStatus) {
            if (uploadFile.avScanStatus == this.failedStatus) {
              console.log(
                'checking the remote file ',
                this.dataService.urlParams.skipFCRemoteList
              );
              this.checkRemoteFile(uploadFile).subscribe((exists) => {
                if (exists) {
                  console.log(
                    'load balanced value ',
                    this.dataService.loadBalanced
                  );
                  if (this.dataService.loadBalanced) {
                    this.fcService
                      .getUserDetails(this.dataService.getFCConnectionKey())
                      .subscribe((resp) => {
                        console.log('User Details Resp ', resp);
                        let serverName: string = resp.userEmailAddress;
                        console.log('server name ', serverName);
                        serverName = serverName.toLowerCase();
                        serverName = serverName.replace('@nowhere.com', '');
                        console.log('server name 2 ', serverName);
                        let serverIndex: number =
                          this.dataService.servers.indexOf[serverName];
                        console.log('server index ', serverIndex);
                        // getting the user details to get the file server
                        uploadFile.server = serverIndex;
                        // this.scanForVirus_V2(uploadFile).
                        this.scanForVirus_V2(uploadFile).subscribe(
                          (scannedFile) => {
                            console.log(
                              'Successfully scanned file ',
                              scannedFile
                            );
                            if (
                              scannedFile.avScanStatus == this.completeStatus
                            ) {
                              // upload file to Agile
                              this.uploadFileToAgile(scannedFile, 0);
                            }
                          }
                        );
                      });
                  } else {
                    this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                      console.log('Successfully scanned file ', scannedFile);
                      if (scannedFile.avScanStatus == this.completeStatus) {
                        // upload file to Agile
                        this.uploadFileToAgile(scannedFile, 0);
                      }
                    });
                  }
                }
              });
            } else if (
              uploadFile.avScanStatus == this.completeStatus &&
              uploadFile.agileUploadStatus == this.failedStatus
            ) {
              this.checkRemoteFile(uploadFile).subscribe((exists) => {
                if (exists) {
                  console.log(
                    'load balanced value ',
                    this.dataService.loadBalanced
                  );
                  if (this.dataService.loadBalanced) {
                    this.fcService
                      .getUserDetails(this.dataService.getFCConnectionKey())
                      .subscribe((resp) => {
                        console.log('User Details Resp ', resp);
                        let serverName: string = resp.userEmailAddress;
                        console.log('server name ', serverName);
                        serverName = serverName.toLowerCase();
                        serverName = serverName.replace('@nowhere.com', '');
                        console.log('server name 2 ', serverName);
                        let serverIndex: number =
                          this.dataService.servers.indexOf[serverName];
                        console.log('server index ', serverIndex);
                        // getting the user details to get the file server
                        uploadFile.server = serverIndex;
                        // this.scanForVirus_V2(uploadFile).

                        this.uploadFileToAgile(uploadFile, 0);
                        // this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                        //   console.log('Successfully scanned file ',scannedFile)
                        //   if(scannedFile.avScanStatus == this.completeStatus){
                        //     // upload file to Agile
                        //     this.uploadFileToAgile(scannedFile);
                        //   }
                        // })
                      });
                  } else {
                    this.uploadFileToAgile(uploadFile, 0);
                    // this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                    //   console.log('Successfully scanned file ',scannedFile)
                    //   if(scannedFile.avScanStatus == this.completeStatus){
                    //     // upload file to Agile
                    //     this.uploadFileToAgile(scannedFile);
                    //   }
                    // })
                  }
                }
              });
            }

            // check file in the server and call the AV Scan service
          } else if (
            uploadFile.fileCacheStatus == this.inProgressStatus ||
            uploadFile.fileCacheStatus == this.notStartedStatus
          ) {
            console.log('Job id ', uploadFile.jobid);
            // check the status for the job id

            // this.scanForVirus(uploadFile);
            this.getFCFileCacheStatus(uploadFile).subscribe((cachedFile) => {
              console.log('Completed File Cache for ', cachedFile.fileName);
              // check if the file is present in the server

              if (
                cachedFile != undefined &&
                cachedFile.fileCacheStatus == this.completeStatus
              ) {
                console.log(
                  'load balanced value ',
                  this.dataService.loadBalanced
                );
                if (this.dataService.loadBalanced) {
                  this.fcService
                    .getUserDetails(this.dataService.getFCConnectionKey())
                    .subscribe((resp) => {
                      console.log('User Details Resp ', resp);
                      let serverName: string = resp.userEmailAddress;
                      console.log('server name ', serverName);
                      serverName = serverName.toLowerCase();
                      serverName = serverName.replace('@nowhere.com', '');
                      console.log('server name 2 ', serverName);
                      let serverIndex: number =
                        this.dataService.servers.indexOf(serverName);
                      console.log('server index ', serverIndex);
                      // getting the user details to get the file server
                      uploadFile.server = serverIndex;
                      this.scanForVirus_V2(uploadFile).subscribe(
                        (scannedFile) => {
                          console.log(
                            'Successfully scanned file ',
                            scannedFile
                          );
                          if (scannedFile.avScanStatus == this.completeStatus) {
                            // upload file to Agile
                            this.uploadFileToAgile(scannedFile, 0);
                          }
                        }
                      );
                    });
                } else {
                  this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                    console.log('Successfully scanned file ', scannedFile);
                    if (scannedFile.avScanStatus == this.completeStatus) {
                      // upload file to Agile
                      this.uploadFileToAgile(scannedFile, 0);
                    }
                  });
                }
                // this.scanForVirus(cachedFile).subscribe((scannedFile) => {
                //   console.log('Successfully scanned file ',scannedFile)
                //   if(scannedFile.fileCacheStatus == this.completeStatus){
                //     // upload file to Agile
                //     this.uploadFileToAgile(scannedFile);
                //   }
                // })
              }
            });
          }
        } else {
          console.log('Non-Accelerated Upload');
          if (uploadFile.fileCacheStatus == this.completeStatus) {
            console.log('Non-Accelerated Upload - File Cache Complete');
            if (uploadFile.avScanStatus == this.failedStatus) {
              console.log(
                'Non-Accelerated Upload - File Cache Complete, failed AV scan'
              );

              // this.scanForVirus_V2(uploadFile).subscribe((scannedFile) => {
              //   console.log('Successfully scanned file ',scannedFile)
              //   if(scannedFile.avScanStatus == this.completeStatus){
              //     // upload file to Agile
              //     this.uploadFileToAgile(scannedFile);
              //   }
              // })

              console.log(
                'load balanced value ',
                this.dataService.loadBalanced
              );
              if (this.dataService.loadBalanced) {
                console.log('inside the load balanced section');
                this.fcService
                  .getUserDetails(this.dataService.getFCConnectionKey())
                  .subscribe((resp) => {
                    console.log('User Details Resp ', resp);
                    let serverName: string = resp.userEmailAddress;
                    serverName = serverName.toLowerCase();
                    console.log('server name ', serverName);
                    serverName = serverName.replace('@nowhere.com', '');
                    console.log('server name 2 ', serverName);
                    let serverIndex: number =
                      this.dataService.servers.indexOf(serverName);
                    console.log('server index ', serverIndex);
                    // getting the user details to get the file server
                    uploadFile.server = serverIndex;
                    this.scanForVirus_V2(uploadFile).subscribe(
                      (scannedFile) => {
                        console.log('Successfully scanned file ', scannedFile);
                        if (scannedFile.avScanStatus == this.completeStatus) {
                          // upload file to Agile
                          this.uploadFileToAgile(scannedFile, 0);
                        }
                      }
                    );
                  });
              } else {
                this.scanForVirus(uploadFile).subscribe((scannedFile) => {
                  console.log('Successfully scanned file ', scannedFile);
                  if (scannedFile.avScanStatus == this.completeStatus) {
                    // upload file to Agile
                    this.uploadFileToAgile(scannedFile, 0);
                  }
                });
              }
            } else if (
              uploadFile.avScanStatus == this.completeStatus &&
              uploadFile.agileUploadStatus == this.failedStatus
            ) {
              this.uploadFileToAgile(uploadFile, 0);
            }
          } else if (
            uploadFile.fileCacheStatus == this.inProgressStatus ||
            uploadFile.fileCacheStatus == this.notStartedStatus
          ) {
            console.log('Non-Accelerated Upload - File Cache in progress');
            this.getNonAcceleratedCacheStatus(uploadFile).subscribe(
              (cachedFile) => {
                console.log('Cached File ', cachedFile);
                if (
                  cachedFile != undefined &&
                  cachedFile.fileCacheStatus == this.completeStatus
                ) {
                  console.log(
                    'load balanced value ',
                    this.dataService.loadBalanced
                  );
                  if (this.dataService.loadBalanced) {
                    console.log(
                      'Non-Accelerated Upload - File Cache Complete, in load balanced loop'
                    );
                    uploadFile.server = 0;
                    // this.scanForVirus_V2
                    this.scanForVirus_V2(uploadFile).subscribe(
                      (scannedFile) => {
                        console.log('Successfully scanned file ', scannedFile);
                        if (scannedFile.avScanStatus == this.completeStatus) {
                          // upload file to Agile
                          this.uploadFileToAgile(scannedFile, 0);
                        }
                      }
                    );
                  } else {
                    this.scanForVirus(cachedFile).subscribe((scannedFile) => {
                      console.log('Successfully scanned file ', scannedFile);
                      if (scannedFile.fileCacheStatus == this.completeStatus) {
                        // upload file to Agile
                        this.uploadFileToAgile(scannedFile, 0);
                      }
                    });
                  }

                  //     this.scanForVirus_V2(uploadFile).subscribe((scannedFile) => {
                  //       console.log('Successfully scanned file ',scannedFile)
                  //       if(scannedFile.avScanStatus == this.completeStatus){
                  //         // upload file to Agile
                  //         this.uploadFileToAgile(scannedFile);
                  //       }
                  //     })

                  // }else{
                  //   this.scanForVirus_V2(uploadFile).subscribe((scannedFile) => {
                  //     console.log('Successfully scanned file ',scannedFile)
                  //     if(scannedFile.avScanStatus == this.completeStatus){
                  //       // upload file to Agile
                  //       this.uploadFileToAgile(scannedFile);
                  //     }
                  //   })
                  // }

                  // this.scanForVirus(cachedFile).subscribe((scannedFile) => {
                  //   console.log('Successfully scanned file ',scannedFile)
                  //   if(scannedFile.fileCacheStatus == this.completeStatus){
                  //     // upload file to Agile
                  //     this.uploadFileToAgile(scannedFile);
                  //   }
                  // })
                }
              }
            );
          }
        }
      });
    }
  }

  async trackDownloads() {
    console.log('in Track downloads method');
    this.downloadFiles = this.dataService.getDownloadFilesInfo();
    console.log('download Files ', this.downloadFiles);
    if (this.downloadFiles != undefined && this.downloadFiles.length > 0) {
      this.downloadValid = true;
    }
    let fileDownloadReqs: AgileFileDownloadRequest =
      this.dataService.getAgileFileDownloadRequests();
    if (fileDownloadReqs != undefined) {
      let completedDownloads: number = this.downloadFiles.filter(
        (value) =>
          value.fcDownloadStatus == this.completeStatus &&
          value.agileDownloadStatus == this.completeStatus
      ).length;
      console.log('Completed Downloads length ', completedDownloads);
      console.log('Download Files Length ', this.downloadFiles.length);
      if (
        fileDownloadReqs.acceleratedTransfer &&
        completedDownloads < this.downloadFiles.length
      ) {
        this.getAcceleratedDownloadStatus(fileDownloadReqs);
      } else if (
        !fileDownloadReqs.acceleratedTransfer &&
        completedDownloads < this.downloadFiles.length
      ) {
        this.getNonAcceleratedDownloadStatus(fileDownloadReqs);
      }
    }
  }

  checkRemoteFile(uploadFile): Observable<boolean> {
    console.log('Checking remote file in from Agile');
    let remoteFileResp: AsyncSubject<boolean> = new AsyncSubject();
    let urlParams: URLParams = this.dataService.getUrlParams();
    let agileFileUploadReq: AgileFileUploadRequest = {
      userName: this.dataService.getUrlParams().userName,
      swbNumber: urlParams.partNumber,
      swbRev: urlParams.partRevision,
      fileName: uploadFile.fileName,
      filePath:
        environment.userUploadsDirectory +
        '/' +
        urlParams.userName +
        '/' +
        urlParams.partNumber,
      fileTypeCode: '',
      fileDestination: '',
      fileDescription: '',
      digitalSign: false,
      server: uploadFile.server,
    };

    this.aglService.checkRemoteFile(agileFileUploadReq).subscribe((exists) => {
      console.log('response from remote file service ', exists);
      if (exists) {
        remoteFileResp.next(true);
        remoteFileResp.complete();
      } else {
        remoteFileResp.next(false);
        remoteFileResp.complete();
      }
    });

    return remoteFileResp.asObservable();
  }

  checkRemoteFile_v2(uploadFile): Observable<boolean> {
    // check if the remote file flag is false, if yes, then wait for 10 seconds and return true
    let urlParams: URLParams = this.dataService.getUrlParams();
    let remoteintvSubs: Subscription;
    let remoteIntv = interval(1000);
    let remoteFileResp: AsyncSubject<boolean> = new AsyncSubject();

    console.log('urlParams.skipFCRemoteList ', urlParams.skipFCRemoteList);
    if (
      urlParams.skipFCRemoteList != undefined &&
      urlParams.skipFCRemoteList.toLowerCase() == 'true'
    ) {
      setTimeout(() => {
        console.log('skipping FC remote file listing ');
        remoteFileResp.next(true);
        remoteFileResp.complete();
      }, 5000);
    } else {
      console.log('calling the FC remote listing ');
      remoteintvSubs = remoteIntv.subscribe(() => {
        // let i:number = 0;
        this.fcService
          .getRemoteFiles(
            urlParams.userName + '/' + urlParams.partNumber,
            this.dataService.fcConnectionKey
          )
          .subscribe((fcResp) => {
            console.log('FC Remote service Response ' + fcResp);
            if (fcResp != undefined && fcResp.fileObjectList != undefined) {
              let filterSize: number = fcResp.fileObjectList.filter((value) => {
                if (value.name == uploadFile.fileName) {
                  return value;
                }
              }).length;
              console.log('Filter size  ', filterSize);
              if (filterSize > 0) {
                if (remoteintvSubs != undefined) {
                  remoteintvSubs.unsubscribe();
                }
                remoteFileResp.next(true);
                remoteFileResp.complete();
              }
            }
          });
      });
    }

    return remoteFileResp.asObservable();
  }

  getFCFileCacheStatus(
    uploadFile: UploadStatusModel
  ): Observable<UploadStatusModel> {
    let urlParams: URLParams = this.dataService.getUrlParams();
    console.log('in Get FC File Cache Status method');
    let statusIntvSubc: Subscription;
    let statusInterval = interval(500);
    let transferStatusResp: AsyncSubject<UploadStatusModel> =
      new AsyncSubject();
    statusIntvSubc = statusInterval.subscribe(() => {
      this.fcService.getTransferStatus(uploadFile.jobid).subscribe(
        (transferStatus) => {
          if (transferStatus != undefined) {
            // console.log('transfer response ',transferStatus);
            if (
              transferStatus.fileTransfers != undefined &&
              transferStatus.fileTransfers.length > 0
            ) {
              transferStatus.fileTransfers.forEach((transfer) => {
                let fileName = transfer.localFilename.substring(
                  transfer.localFilename.lastIndexOf('\\') + 1
                );
                // console.log('File Name ',fileName)

                // console.log('upload file ',uploadFile)
                if (uploadFile.fileName == fileName) {
                  uploadFile.fileCacheStatus = this.inProgressStatus;
                  uploadFile.fileCacheMessage.Transfer_Rate =
                    transfer.currentRate.toString();
                  uploadFile.fileCacheMessage.Current_Percent =
                    transfer.currentPercent.toString();
                  uploadFile.fileCacheMessage.Time_Remaining = (
                    transfer.currentFileTimeRemaining / 60000
                  ).toFixed(2);
                  uploadFile.fileCacheMessage.Transfer_Mode =
                    transferModes[transferStatus.transferMode - 1];
                  // this.uploadFiles[index] = uploadFile;
                  if (transfer.currentPercent == 100) {
                    uploadFile.fileCacheStatus = this.completeStatus;
                    uploadFile.fileCacheMessage.Transfer_Rate = '0';
                    if (statusIntvSubc != undefined) {
                      statusIntvSubc.unsubscribe();
                    }

                    transferStatusResp.next(uploadFile);
                    transferStatusResp.complete();
                    // let remoteintvSubs : Subscription;
                    // let remoteIntv = interval(1000);

                    // remoteintvSubs = remoteIntv.subscribe(
                    //   () =>
                    //   {
                    //     // let i:number = 0;
                    //     this.fcService.getRemoteFiles(urlParams.userName+"/"+urlParams.partNumber,this.dataService.fcConnectionKey).subscribe(
                    //       (fcResp) =>{
                    //         console.log('FC Remote service Response '+fcResp)
                    //         if(fcResp != undefined && fcResp.fileObjectList != undefined)
                    //         {
                    //           let filterSize:number = fcResp.fileObjectList.filter((value) => {if(value.name == uploadFile.fileName){return value;}}).length;
                    //           console.log('Filter size  ',filterSize)
                    //           if(filterSize > 0){
                    //             if(remoteintvSubs != undefined){
                    //               remoteintvSubs.unsubscribe();
                    //             }
                    //             transferStatusResp.next(uploadFile);
                    //             transferStatusResp.complete();
                    //           }
                    //         }
                    //       })
                    //     })

                    // this.checkRemoteFile(uploadFile).subscribe(
                    //   (exists) => {
                    //     if(exists){
                    //       transferStatusResp.next(uploadFile);
                    //       transferStatusResp.complete();
                    //     }
                    //   })
                    // this.scanForVirus(uploadFile);
                    // transferResponse.next(index);
                  }
                }
              });
            }
            if (
              transferStatus.transferErrors != undefined &&
              transferStatus.transferErrors.length > 0
            ) {
              transferStatus.transferErrors.forEach((transferError) => {
                if (uploadFile.fileName == transferError.file) {
                  uploadFile.fileCacheStatus = this.failedStatus;
                  uploadFile.fileCacheMessage.error_message =
                    transferError.error;
                  if (statusIntvSubc != undefined) {
                    statusIntvSubc.unsubscribe();
                  }
                  transferStatusResp.next(uploadFile);
                  transferStatusResp.complete();
                  // transferResponse.next(index);
                }
              });
            }
            if (
              transferStatus.completedFiles != undefined &&
              transferStatus.completedFiles.length > 0
            ) {
              transferStatus.completedFiles.forEach((completedFile) => {
                let fileName = completedFile.substring(
                  completedFile.lastIndexOf('\\') + 1
                );
                // console.log('Completed file name ',fileName)
                if (uploadFile.fileName == fileName) {
                  if (uploadFile.fileCacheStatus == this.inProgressStatus) {
                    uploadFile.fileCacheStatus = this.completeStatus;
                    if (transferStatus.transferComplete) {
                      if (statusIntvSubc != undefined) {
                        statusIntvSubc.unsubscribe();
                      }
                    }
                    transferStatusResp.next(uploadFile);
                    transferStatusResp.complete();
                    // transferResponse.complete();
                  }
                }
              });
            }
          }
        },
        (error) => {
          console.log('error ', error);
          uploadFile.fileCacheStatus = this.failedStatus;
          uploadFile.fileCacheMessage.error_message = error;
        }
      );
    });
    return transferStatusResp.asObservable();
  }

  getFCFileCacheStatus_v2(
    uploadFile: UploadStatusModel
  ): Observable<UploadStatusModel> {
    let urlParams: URLParams = this.dataService.getUrlParams();
    console.log('in Get FC File Cache Status method');
    let statusIntvSubc: Subscription;
    let statusInterval = interval(500);
    let transferStatusResp: AsyncSubject<UploadStatusModel> =
      new AsyncSubject();
    statusIntvSubc = statusInterval.subscribe(() => {
      this.fcService.getTransferStatus(uploadFile.jobid).subscribe(
        (transferStatus) => {
          if (transferStatus != undefined) {
            // console.log('transfer response ',transferStatus);
            if (
              transferStatus.fileTransfers != undefined &&
              transferStatus.fileTransfers.length > 0
            ) {
              transferStatus.fileTransfers.forEach((transfer) => {
                let fileName = transfer.localFilename.substring(
                  transfer.localFilename.lastIndexOf('\\') + 1
                );
                // console.log('File Name ',fileName)

                // console.log('upload file ',uploadFile)
                if (uploadFile.fileName == fileName) {
                  uploadFile.fileCacheStatus = this.inProgressStatus;
                  uploadFile.fileCacheMessage.Transfer_Rate =
                    transfer.currentRate.toString();
                  uploadFile.fileCacheMessage.Current_Percent =
                    transfer.currentPercent.toString();
                  uploadFile.fileCacheMessage.Time_Remaining = (
                    transfer.currentFileTimeRemaining / 60000
                  ).toFixed(2);
                  uploadFile.fileCacheMessage.Transfer_Mode =
                    transferModes[transferStatus.transferMode - 1];
                  // this.uploadFiles[index] = uploadFile;
                  if (transfer.currentPercent == 100) {
                    uploadFile.fileCacheStatus = this.completeStatus;
                    uploadFile.fileCacheMessage.Transfer_Rate = '0';
                    if (statusIntvSubc != undefined) {
                      statusIntvSubc.unsubscribe();
                    }

                    // let remoteintvSubs : Subscription;
                    // let remoteIntv = interval(1000);

                    // remoteintvSubs = remoteIntv.subscribe(
                    //   () =>
                    //   {
                    //     // let i:number = 0;
                    //     this.fcService.getRemoteFiles(urlParams.userName+"/"+urlParams.partNumber,this.dataService.fcConnectionKey).subscribe(
                    //       (fcResp) =>{
                    //         console.log('FC Remote service Response '+fcResp)
                    //         if(fcResp != undefined && fcResp.fileObjectList != undefined)
                    //         {
                    //           let filterSize:number = fcResp.fileObjectList.filter((value) => {if(value.name == uploadFile.fileName){return value;}}).length;
                    //           console.log('Filter size  ',filterSize)
                    //           if(filterSize > 0){
                    //             if(remoteintvSubs != undefined){
                    //               remoteintvSubs.unsubscribe();
                    //             }
                    //             transferStatusResp.next(uploadFile);
                    //             transferStatusResp.complete();
                    //           }
                    //         }
                    //       })
                    //     })

                    this.checkRemoteFile(uploadFile).subscribe((exists) => {
                      if (exists) {
                        transferStatusResp.next(uploadFile);
                        transferStatusResp.complete();
                      }
                    });
                    // this.scanForVirus(uploadFile);
                    // transferResponse.next(index);
                  }
                }
              });
            }
            if (
              transferStatus.transferErrors != undefined &&
              transferStatus.transferErrors.length > 0
            ) {
              transferStatus.transferErrors.forEach((transferError) => {
                if (uploadFile.fileName == transferError.file) {
                  uploadFile.fileCacheStatus = this.failedStatus;
                  uploadFile.fileCacheMessage.error_message =
                    transferError.error;
                  if (statusIntvSubc != undefined) {
                    statusIntvSubc.unsubscribe();
                  }
                  transferStatusResp.next(uploadFile);
                  transferStatusResp.complete();
                  // transferResponse.next(index);
                }
              });
            }
            if (
              transferStatus.completedFiles != undefined &&
              transferStatus.completedFiles.length > 0
            ) {
              transferStatus.completedFiles.forEach((completedFile) => {
                let fileName = completedFile.substring(
                  completedFile.lastIndexOf('\\') + 1
                );
                console.log('Completed file name ', fileName);
                if (uploadFile.fileName == fileName) {
                  if (uploadFile.fileCacheStatus == this.inProgressStatus) {
                    uploadFile.fileCacheStatus = this.completeStatus;
                    if (transferStatus.transferComplete) {
                      if (statusIntvSubc != undefined) {
                        statusIntvSubc.unsubscribe();
                      }
                    }
                    transferStatusResp.next(uploadFile);
                    transferStatusResp.complete();
                    // transferResponse.complete();
                  }
                }
              });
            }
          }
        },
        (error) => {
          console.log('error ', error);
          uploadFile.fileCacheStatus = this.failedStatus;
          uploadFile.fileCacheMessage.error_message = error;
        }
      );
    });
    return transferStatusResp.asObservable();
  }

  getNonAcceleratedCacheStatus(
    uploadFile: UploadStatusModel
  ): Observable<UploadStatusModel> {
    let transferStatusResp: AsyncSubject<UploadStatusModel> =
      new AsyncSubject();
    let fileCacheReq: FileCacheWARequest = {
      file: uploadFile.file,
      fileName: uploadFile.fileName,
      filePath: '',
      userName: this.dataService.urlParams.userName,
      swbNumber: this.dataService.urlParams.partNumber,
    };
    uploadFile.fileCacheStatus = this.inProgressStatus;
    uploadFile.fileCacheMessage.upload_message = 'Caching File to server..';
    this.aglService.fileCacheWithoutAcceleration(fileCacheReq).subscribe(
      (fileCacheResp) => {
        console.log('File Cache Resp ', fileCacheResp);
        if (fileCacheResp.fileDownloaded) {
          uploadFile.fileCacheStatus = this.completeStatus;
          uploadFile.fileCacheMessage.upload_message =
            'Cached File to server..';
          transferStatusResp.next(uploadFile);
          transferStatusResp.complete();
          //call Agile Upload
          // this.uploadFileToAgile(uploadFile,index);
        }
      },
      (error) => {
        uploadFile.fileCacheStatus = this.failedStatus;
        (uploadFile.fileCacheMessage.upload_message =
          'Failed to cache file to server..'),
          error;
        transferStatusResp.next(uploadFile);
        transferStatusResp.complete();
      }
    );

    return transferStatusResp.asObservable();
  }

  getFCDownloadStatus(downloadFile: DownloadStatusModel) {
    console.log('in Get FC File download Status method');
    let statusIntvSubc: Subscription;
    let statusInterval = interval(500);
    let transferStatusResp: AsyncSubject<DownloadStatusModel> =
      new AsyncSubject();
    statusIntvSubc = statusInterval.subscribe(() => {
      this.fcService.getTransferStatus(downloadFile.jobid).subscribe(
        (transferStatus) => {
          if (transferStatus != undefined) {
            console.log('transfer response ', transferStatus);
            if (
              transferStatus.fileTransfers != undefined &&
              transferStatus.fileTransfers.length > 0
            ) {
              transferStatus.fileTransfers.forEach((transfer) => {
                let fileName = transfer.currentFilename.substring(
                  transfer.localFilename.lastIndexOf('\\') + 1
                );
                console.log('File Name ', fileName);
                console.log('Download File Name ', downloadFile.fileName);

                // console.log('upload file ',uploadFile)
                if (downloadFile.fileName == fileName) {
                  downloadFile.fcDownloadStatus = this.inProgressStatus;
                  downloadFile.fileDownloadMessage.Transfer_Rate =
                    transfer.currentRate.toString();
                  downloadFile.fileDownloadMessage.Current_Percent =
                    transfer.currentPercent.toString();
                  downloadFile.fileDownloadMessage.Time_Remaining = (
                    transfer.currentFileTimeRemaining / 60000
                  ).toFixed(2);
                  downloadFile.fileDownloadMessage.Transfer_Mode =
                    transferModes[transferStatus.transferMode - 1];
                  downloadFile.fileDownloadMessage.Download_Location =
                    transferStatus.downloadLocation;
                  // this.uploadFiles[index] = uploadFile;
                  if (transfer.currentPercent == 100) {
                    downloadFile.fcDownloadStatus = this.completeStatus;
                    downloadFile.fileDownloadMessage.Transfer_Rate = '0';
                    if (statusIntvSubc != undefined) {
                      statusIntvSubc.unsubscribe();
                    }
                    transferStatusResp.next(downloadFile);
                    transferStatusResp.complete();
                    // transferResponse.next(index);
                  }
                }
              });
            }
            if (
              transferStatus.transferErrors != undefined &&
              transferStatus.transferErrors.length > 0
            ) {
              transferStatus.transferErrors.forEach((transferError) => {
                if (downloadFile.fileName == transferError.file) {
                  downloadFile.fcDownloadStatus = this.failedStatus;
                  downloadFile.fileDownloadMessage.error_message =
                    transferError.error;
                  if (statusIntvSubc != undefined) {
                    statusIntvSubc.unsubscribe();
                  }
                  transferStatusResp.next(downloadFile);
                  transferStatusResp.complete();
                  // transferResponse.next(index);
                }
              });
            }
            if (
              transferStatus.completedFiles != undefined &&
              transferStatus.completedFiles.length > 0
            ) {
              transferStatus.completedFiles.forEach((completedFile) => {
                let fileName = completedFile.substring(
                  completedFile.lastIndexOf('\\') + 1
                );
                console.log('Completed file name ', fileName);
                if (downloadFile.fileName == fileName) {
                  if (downloadFile.fcDownloadStatus == this.inProgressStatus) {
                    downloadFile.fcDownloadStatus = this.completeStatus;
                    if (transferStatus.transferComplete) {
                      if (statusIntvSubc != undefined) {
                        statusIntvSubc.unsubscribe();
                      }
                    }
                    transferStatusResp.next(downloadFile);
                    transferStatusResp.complete();
                    // transferResponse.complete();
                  }
                }
              });
            }
          }
        },
        (error) => {
          console.log('error ', error);
          downloadFile.fcDownloadStatus = this.failedStatus;
          downloadFile.fileDownloadMessage.error_message = error;
        }
      );
    });
    return transferStatusResp.asObservable();
  }

  getAcceleratedDownloadStatus(fileDownloadReqs: AgileFileDownloadRequest) {
    let downloadFilesInfo: DownloadFilesInfo[] =
      fileDownloadReqs.downloadFilesInfo;
    this.downloadFiles.forEach((downloadFile) => {
      downloadFilesInfo.forEach((value) => {
        if (
          downloadFile.fileName == value.fileName &&
          downloadFile.agileDownloadStatus != this.completeStatus
        ) {
          downloadFile.agileDownloadStatus = this.inProgressStatus;
          downloadFile.agileDownloadMessage = 'Getting File from Agile..';
        }
      });
    });

    this.aglService
      .downloadFileToUNC(fileDownloadReqs)
      .subscribe((downloadResp) => {
        console.log('Download Response ', downloadResp);
        if (downloadResp.processCompleted) {
          if (downloadResp.downloadFileResponse != undefined) {
            let downloadFilesList: string[] = [];
            downloadResp.downloadFileResponse.forEach((downloadFile) => {
              console.log('Downloaded flag ', downloadFile.downloaded);
              console.log('Download File ', downloadFile);
              if (downloadFile.downloaded) {
                this.downloadFiles.filter((value) => {
                  if (value.fileName == downloadFile.fileName) {
                    value.agileDownloadStatus = this.completeStatus;
                    value.agileDownloadMessage = downloadFile.downloadMessage;
                  }
                });

                downloadFilesList.push(downloadFile.fileLocation);
              } else {
                this.downloadFiles.filter((value) => {
                  if (value.fileName == downloadFile.fileName) {
                    value.agileDownloadStatus = this.failedStatus;
                    value.agileDownloadMessage = downloadFile.downloadMessage;
                  }
                });
              }
            });

            if (downloadFilesList.length > 0) {
              this.fcService.getFCDownloadConnection().subscribe(
                (response) => {
                  console.log('Download Connection response ', response);
                  this.fcService
                    .initiateFCDownloadTransfer(
                      response.connectionKey,
                      downloadFilesList
                    )
                    .subscribe(
                      (dResponse) => {
                        console.log('Download Request Response ', dResponse);
                        if (dResponse != undefined) {
                          fileDownloadReqs.transferComplete = true;
                          downloadFilesList.forEach((downloadFile) => {
                            let fileName = downloadFile.substring(
                              downloadFile.lastIndexOf('/') + 1
                            );
                            this.downloadFiles.forEach((file) => {
                              console.log('download file ', fileName);
                              console.log(' file ', file.fileName);
                              if (file.fileName == fileName) {
                                file.jobid = dResponse.jobId;
                              }
                            });
                            // this.downloadFiles.filter((value) => {if(value.fileName == downloadFile){value.jobid = dResponse.jobId}})
                          });
                          console.log('Download Files ', this.downloadFiles);
                          if (
                            this.downloadFiles != undefined &&
                            this.downloadFiles.length > 0
                          ) {
                            this.downloadValid = true;
                            this.downloadFiles.forEach((downloadFile) => {
                              if (
                                downloadFile.fcDownloadStatus ==
                                this.completeStatus
                              ) {
                              } else if (
                                downloadFile.fcDownloadStatus ==
                                  this.inProgressStatus ||
                                downloadFile.fcDownloadStatus ==
                                  this.notStartedStatus
                              ) {
                                this.getFCDownloadStatus(downloadFile);
                              }
                            });
                          }
                        }
                        // this.router.navigate(['transferstatus'],{skipLocationChange:true})
                        // this.getAllTransfers();
                      },
                      (error) => {
                        console.log('error ', error);
                        downloadFilesList.forEach((downloadFile) => {
                          this.downloadFiles.filter((value) => {
                            if (value.fileName == downloadFile) {
                              value.fcDownloadStatus = this.failedStatus;
                            }
                          });
                        });
                      }
                    );
                },
                (error) => {
                  console.log('error ', error);
                  downloadFilesList.forEach((downloadFile) => {
                    this.downloadFiles.filter((value) => {
                      if (value.fileName == downloadFile) {
                        value.fcDownloadStatus = this.failedStatus;
                      }
                    });
                  });
                }
              );
            } else {
              // route to transfer status with error message
            }
          }
        } else {
          console.log(
            'error while downloading the file ',
            downloadResp.errorMessage
          );
        }
      });
  }

  getNonAcceleratedDownloadStatus(fileDownloadReqs: AgileFileDownloadRequest) {
    if (fileDownloadReqs != undefined) {
      let downloadFilesList: DownloadFilesInfo[] =
        fileDownloadReqs.downloadFilesInfo;
      downloadFilesList.forEach((fileInfo) => {
        this.downloadFiles.filter((value) => {
          if (value.fileName == fileInfo.fileName) {
            value.agileDownloadStatus = this.inProgressStatus;
            value.agileDownloadMessage = 'Getting file from Agile...';
          }
        });
      });

      this.aglService.downloadZipFileByteResponse(fileDownloadReqs).subscribe(
        (data) => {
          if (data.size == 0) {
            this.downloadFiles.forEach((value) => {
              value.agileDownloadStatus = this.failedStatus;
              value.agileDownloadMessage = 'File not found in Agile FM..';
            });
          } else {
            this.downloadFiles.forEach((value) => {
              value.agileDownloadStatus = this.completeStatus;
              value.agileDownloadMessage = 'Fetched file details from Agile.';
            });
            console.log('Before Save AS ' + new Date());
            // this.openProgressBar();

            this.downloadFiles.forEach((value) => {
              value.fcDownloadStatus = this.inProgressStatus;
            });
            let fileName = 'AgileDownloads.zip';
            if (
              this.dataService.urlParams.partNumber != undefined &&
              this.dataService.urlParams.partNumber != ''
            ) {
              if (fileDownloadReqs.downloadFilesInfo.length === 1) {
                fileName = fileDownloadReqs.downloadFilesInfo[0].fileName;
              } else {
                fileName = this.dataService.urlParams.partNumber + '.zip';
              }
            }
            saveAs(data, fileName);
            this.downloadFiles.forEach((value) => {
              value.fcDownloadStatus = this.completeStatus;
              value.fileDownloadMessage.download_message = 'Dowloaded File.';
            });

            console.log('After Save AS ' + new Date());
          }

          // this.closeProgresBar();
        },
        (error) => {
          this.downloadFiles.forEach((value) => {
            value.agileDownloadStatus = this.failedStatus;
            value.agileDownloadMessage =
              'Unable to fetch file from Agile..' + error;
          });
        }
      );
    }
  }
  scanForVirus(uploadFile: UploadStatusModel): Observable<UploadStatusModel> {
    // console.log('Index on Virus scan method ',index)
    // let index:number
    // this.uploadFiles.filter((value,i) => {if(value.fileName == uploadFileName){
    //   index = i;
    // }});
    uploadFile.avScanStatus = this.inProgressStatus;
    (uploadFile.avsScanMessage = 'Scanning File '), uploadFile.fileName;
    let querySubject: AsyncSubject<UploadStatusModel> = new AsyncSubject();
    let avScanRespSubs: Subscription;
    let avScanRespIntv = interval(5000);
    let scanResp: ScanResponseInfo = new ScanResponseInfo();
    let urlParams: URLParams = this.dataService.getUrlParams();
    let fileNameWithPath =
      urlParams.userName +
      '\\' +
      urlParams.partNumber +
      '\\' +
      uploadFile.fileName;
    // fileNameWithPath = uploadFile.server+'/'+fileNameWithPath;

    this.avScanServ.submitForAVScan(fileNameWithPath).subscribe(
      (scanSubmitResp) => {
        // console.log('Scan Submit Response ',scanSubmitResp)
        if (scanSubmitResp.submitted) {
          avScanRespSubs = avScanRespIntv.subscribe(() => {
            this.avScanServ.getAVScanStatus(fileNameWithPath).subscribe(
              (scanStatus) => {
                if (scanStatus != undefined && scanStatus.complete) {
                  console.log('Scan Status ', scanStatus);

                  if (scanStatus.clean) {
                    uploadFile.avScanStatus = this.completeStatus;
                    uploadFile.avsScanMessage = scanStatus.message;
                  } else {
                    uploadFile.avScanStatus = this.failedStatus;
                    uploadFile.avsScanMessage = scanStatus.message;
                  }
                  querySubject.next(uploadFile);
                  querySubject.complete();
                  if (avScanRespSubs != undefined) {
                    console.log(
                      'Unsubscribing the AV interval for ',
                      fileNameWithPath
                    );
                    avScanRespSubs.unsubscribe();
                  }
                  // scanResp = scanStatus;
                }
              },
              (error) => {
                uploadFile.avScanStatus = this.failedStatus;
                uploadFile.avsScanMessage = error;
                querySubject.next(uploadFile);
                querySubject.complete();
              }
            );
          });
        }
      },
      (error) => {
        uploadFile.avScanStatus = this.failedStatus;
        uploadFile.avsScanMessage = error;
        querySubject.next(uploadFile);
        querySubject.complete();
      }
    );
    console.log('returning Scan response ', scanResp);
    return querySubject.asObservable();
  }

  scanForVirus_V2(
    uploadFile: UploadStatusModel
  ): Observable<UploadStatusModel> {
    // console.log('Index on Virus scan method ',index)
    // let index:number
    // this.uploadFiles.filter((value,i) => {if(value.fileName == uploadFileName){
    //   index = i;
    // }});
    console.log('Scanning file ', uploadFile);

    let querySubject: AsyncSubject<UploadStatusModel> = new AsyncSubject();

    // let scanResp:ScanResponseInfo = new ScanResponseInfo();
    let urlParams: URLParams = this.dataService.getUrlParams();
    let fileNameWithPath =
      urlParams.userName +
      '\\' +
      urlParams.partNumber +
      '\\' +
      uploadFile.fileName;
    // fileNameWithPath = uploadFile.server+'/'+fileNameWithPath;
    let fileScanRequest: AVScanReq = {
      fileName: fileNameWithPath,
      server: uploadFile.server,
    };

    console.log('Submitting for scan for ', fileScanRequest);
    this.avScanServ.submitForAVScanV2(fileScanRequest).subscribe(
      (scanSubmitResp) => {
        uploadFile.avScanStatus = this.inProgressStatus;
        (uploadFile.avsScanMessage = 'Scanning File '), uploadFile.fileName;
        let avScanRespSubs: Subscription;
        let avScanRespIntv = interval(5000);
        console.log('Scan Submit Response ', scanSubmitResp);
        if (scanSubmitResp.submitted) {
          avScanRespSubs = avScanRespIntv.subscribe(() => {
            this.avScanServ.getAVScanStatus(fileNameWithPath).subscribe(
              (scanStatus) => {
                if (scanStatus != undefined && scanStatus.complete) {
                  console.log('Scan Status ', scanStatus);

                  if (scanStatus.clean) {
                    uploadFile.avScanStatus = this.completeStatus;
                    uploadFile.avsScanMessage = scanStatus.message;
                  } else {
                    uploadFile.avScanStatus = this.failedStatus;
                    uploadFile.avsScanMessage = scanStatus.message;
                  }
                  querySubject.next(uploadFile);
                  querySubject.complete();
                  if (avScanRespSubs != undefined) {
                    console.log(
                      'Unsubscribing the AV interval for ',
                      fileNameWithPath
                    );
                    avScanRespSubs.unsubscribe();
                  }
                  // scanResp = scanStatus;
                }
              },
              (error) => {
                uploadFile.avScanStatus = this.failedStatus;
                uploadFile.avsScanMessage = error;
                querySubject.next(uploadFile);
                querySubject.complete();
              }
            );
          });
        }
      },
      (error) => {
        uploadFile.avScanStatus = this.failedStatus;
        uploadFile.avsScanMessage = error;
        querySubject.next(uploadFile);
        querySubject.complete();
      }
    );
    // console.log('returning Scan response ',scanResp)
    return querySubject.asObservable();
  }

  uploadFileToAgile(uploadFile: UploadStatusModel, trial: number) {
    // check if the Agile session is active, if not, give the popup
    console.log('check 1');
    this.checkAgileSession().subscribe((status) => {
      console.log('Agile session status -- ', status);
      if (status) {
        let urlParams: URLParams = this.dataService.getUrlParams();

        // console.log('agile File Info ',agileFileInfo)
        let uploadFileInfo = this.dataService.getAgileFileInfoForFile(
          uploadFile.fileName
        );
        console.log('Upload File Info from Data Service ', uploadFileInfo);
        let i = 0;
        if (uploadFileInfo != undefined) {
          // let fileNameWithPath = urlParams.userName+"\\"+urlParams.partNumber+"\\"+uploadFile.fileName;

          // perform the Agile upload activities
          console.log(
            'Found file in the server, calling the Agile upload now '
          );

          console.log(
            'upload file replace flag? ',
            uploadFileInfo.replaceAction
          );

          if (
            uploadFileInfo.replaceAction != undefined &&
            uploadFileInfo.replaceAction == true
          ) {
            // replace files
            let agileReplaceFileReq: AgileReplaceFileRequest = {
              userName: this.dataService.getUrlParams().userName,
              partNumber: urlParams.partNumber,
              partRev: urlParams.partRevision,
              server: uploadFile.server,
              replaceFileInfoList: [
                {
                  fileName: uploadFile.fileName,
                  oldFileName: uploadFileInfo.oldFileName,
                  // filePath:environment.userUploadsDirectory+"/"+urlParams.userName+"/"+urlParams.partNumber,
                  filePath: '',
                  fileTypeCode: uploadFileInfo.fileTypeCode,
                  digitalSign: uploadFileInfo.digitalSign,
                },
              ],
            };

            if (i == 0) {
              i++;
              console.log(
                'Calling the Agile Replace service ',
                agileReplaceFileReq
              );
              uploadFile.agileUploadStatus = this.inProgressStatus;
              uploadFile.agileUploadMessage = 'Replacing File in Agile...';

              this.aglService
                .replaceAgileFile(agileReplaceFileReq)
                .subscribe((response) => {
                  console.log('Agile Upload response ', response);
                  this.uploadFiles.forEach((uploadFile, index) => {
                    if (
                      response.replaceFileInfoList != undefined &&
                      response.replaceFileInfoList.length > 0
                    ) {
                      for (
                        let i = 0;
                        i < response.replaceFileInfoList.length;
                        i++
                      ) {
                        if (
                          uploadFile.fileName ==
                          response.replaceFileInfoList[i].fileName
                        ) {
                          if (response.replaceFileInfoList[i].replaced) {
                            this.uploadFiles[index].agileUploadStatus =
                              this.completeStatus;
                            this.uploadFiles[index].agileUploadMessage =
                              'Successfully replaced file';
                          } else {
                            this.uploadFiles[index].agileUploadStatus =
                              this.failedStatus;
                            this.uploadFiles[index].agileUploadMessage =
                              response.replaceFileInfoList[i].errorMessage;
                          }
                        }
                      }
                    }
                  });
                });

              (error) => {
                console.log('Error while uploading the file ', error);
                uploadFile.agileUploadStatus = this.failedStatus;
                uploadFile.agileUploadMessage =
                  'Error while uploading file to Agile.';
                if (trial < 3) {
                  console.log('retrial ' + trial);
                  trial = trial + 1;
                  // this.uploadFileToAgile(uploadFile,trial);
                }
              };
            }
          } else {
            let agileFileUploadReq: AgileFileUploadRequest = {
              userName: this.dataService.getUrlParams().userName,
              swbNumber: urlParams.partNumber,
              swbRev: urlParams.partRevision,
              fileName: uploadFile.fileName,
              // filePath:environment.userUploadsDirectory+"/"+urlParams.userName+"/"+urlParams.partNumber,
              filePath: '',
              fileTypeCode: uploadFileInfo.fileTypeCode,
              fileDestination: uploadFileInfo.fileDestination,
              fileDescription: uploadFile.fileName.substring(0, 100),
              digitalSign: uploadFileInfo.digitalSign,
              server: uploadFile.server,
            };

            if (i == 0) {
              i++;

              if (uploadFile.agileUploadStatus != this.completeStatus) {
                console.log(
                  'Calling the Agile upload service ',
                  agileFileUploadReq
                );
                uploadFile.agileUploadStatus = this.inProgressStatus;
                uploadFile.agileUploadMessage = 'Uploading File To Agile...';

                this.aglService
                  .uploadFileToAgileFromServer(agileFileUploadReq)
                  .subscribe(
                    (response) => {
                      console.log('Agile Upload response ', response);
                      this.uploadFiles.forEach((uploadFile, index) => {
                        if (uploadFile.fileName == response.fileName) {
                          if (response.uploaded) {
                            this.uploadFiles[index].agileUploadStatus =
                              this.completeStatus;
                            this.uploadFiles[index].agileUploadMessage =
                              response.uploadMessage;

                            console.log(
                              'Hardware Rel Info ',
                              response.hardwareRelMappingInfo
                            );
                            console.log(
                              'Hardware Rel Info Part Num ',
                              response.hardwareRelMappingInfo.partNumber
                            );
                            if (
                              response.hardwareRelMappingInfo != undefined &&
                              response.hardwareRelMappingInfo.partNumber !=
                                undefined
                            ) {
                              if (response.hardwareRelMappingInfo.hasInfo) {
                                this.dataService.setHardwareRelInfo(
                                  response.hardwareRelMappingInfo
                                );
                                this.router.navigate(['relmapping'], {
                                  skipLocationChange: true,
                                });
                              }
                            }
                          } else {
                            this.uploadFiles[index].agileUploadStatus =
                              this.failedStatus;
                            this.uploadFiles[index].agileUploadMessage =
                              response.uploadMessage;
                            if (trial < 3) {
                              console.log('retrying upload ', trial);
                              trial = trial + 1;
                              // this.uploadFileToAgile(uploadFile,trial);
                            }
                          }
                        }
                      });
                    },
                    (error) => {
                      console.error('error while uploading file ', error);
                      uploadFile.agileUploadStatus = this.failedStatus;
                      uploadFile.agileUploadMessage = error;
                      if (trial < 3) {
                        console.log('retrying upload ', trial);
                        trial = trial + 1;
                        // this.uploadFileToAgile(uploadFile,trial);
                      }
                    }
                  );
              }
            }
          }
        } else {
          uploadFile.agileUploadStatus = this.failedStatus;
          uploadFile.agileUploadMessage = 'Invalid File Details';
        }
      } else {
        console.log('in the else block');
        let confirm = window.confirm(
          'Agile session is expired. Please login in to Agile, click home and then transfer status to resume the upload.'
        );
        if (confirm) {
          // check the session again and proceed to upload, else upload to Agile
          this.uploadFileToAgile(uploadFile, trial);
        }
      }
    });
  }

  checkAgileSession(): Observable<boolean> {
    console.log('checking Agile session info...');
    let querySubject: AsyncSubject<boolean> = new AsyncSubject();
    this.aglService.getAgileSessionInfo().subscribe((status) => {
      console.log('is session active? ', status);
      querySubject.next(status);
      querySubject.complete();
    });
    return querySubject;
  }
}
const statusCodes = [
  'Not Attempted',
  'Success',
  'Cancelled',
  'Error',
  'Transferring',
  'Verifying file integrity via MD5',
  'Initializing',
  'Doing MDTM (Maintain date/timestamp for modification time)',
  'Doing CHMOD (Changing permissions on a file)',
  'Finished',
  'Done file',
  'Checking',
  'Creating signature files',
  'Creating delta files',
  'Rebuild',
  'Creating DMG file for rebuilding',
  'Moving files',
  'Reconnecting',
  'Decompressing',
  'Monitoring',
];

const transferModes = ['FTP', 'AUTO', 'HTTP', 'UDP', 'SFTP'];
